// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".address-information[data-v-30aa7253] {\n  margin-top: 0;\n  position: relative;\n  text-align: center;\n  padding-bottom: 10px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.25);\n}\n.address-information p[data-v-30aa7253] {\n  line-height: 1.2;\n  font-size: 14px;\n  margin: 10px 0 0;\n  font-weight: 400;\n}", ""]);
// Exports
module.exports = exports;
